import apiService, { ApiService } from './ApiService';
import { apis } from '../utility/constants';
import { List, ListParams } from '../types/main';
import { ItemId, Article, ArticleComment } from '../types/items';
import { ArticleDocumentForm, ArticleVideoForm, LockMediaToProjectForm } from '../types/formItems';
import { transformList } from './transformer';
import { UploadFromUrlRequest } from '../store/modules/articles/types';

class ArticleService {
  private route = apis.articles;

  constructor(private api: ApiService) {}

  list = (params: ListParams) => this.api.get<List<Article>>(this.route.default, params).then(transformList);

  get = (id: ItemId) => this.api.get<Article>(`${this.route.default}/${id}`);

  template = () => this.api.get<Article>(`${this.route.default}/new`);

  save = (article: Article | LockMediaToProjectForm) => this.api.put(`${this.route.default}/${article.id}`, article);

  create = (article: Article) => this.api.post<Article>(this.route.default, article);

  createDocument = (article: ArticleDocumentForm) => this.api
    .post<Article>(`${this.route.default}/new/document`, article);

  createVideo = (article: ArticleVideoForm) => this.api.post<Article>(`${this.route.default}/new/video`, article);

  delete = (id: ItemId) => this.api.delete(`${this.route.default}/${id}`);

  createActivityComment = (comment: ArticleComment) => this.api.post<Article>(this.route.default, comment);

  uploadMediaFromUrl = (videoId: number, url: string) => this.api.put(this.route.uploadVideoFromUrl(videoId), { url });

  uploadVideoFromAnotherResource = (form: UploadFromUrlRequest) => this.api
    .post(`${this.route.default}/new/video-from-url`, form);
}

export default new ArticleService(apiService);
